/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * Factory which builds a filter that negates a variable, useful when needing to inverse the result of a previous
 * filter.
 *
 * @ngInject
 */
function NotFilterFactory($log) {
    const filter = function(data) {
        return !data;
    };

    $log.debug('Factory \'NotFilter\' loaded');
    return filter;
}

export { NotFilterFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/filter/NotFilter.js